// src/js-dot/text/functions/get-kr-pp.ts
var KR_PP = ["\uC774", "\uAC00", "\uC73C\uB85C", "\uB85C", "\uC73C\uB85C\uC11C", "\uB85C\uC11C", "\uC73C\uB85C\uC368", "\uB85C\uC368", "\uC744", "\uB97C", "\uC740", "\uB294", "\uACFC", "\uC640"];
function getKrPp(word, pp) {
  let lastCharCode = word.charAt(word.length - 1).charCodeAt(0);
  if (44032 > lastCharCode && lastCharCode < 55203) {
    return "";
  }
  let supported = KR_PP.indexOf(pp);
  if (supported < 0) {
    return "";
  }
  const hasFinalSound = (lastCharCode - 44032) % 28 > 0;
  return KR_PP[hasFinalSound ? supported % 2 ? supported - 1 : supported : supported % 2 ? supported : supported + 1];
}

// src/js-dot/text/functions/get-plural.ts
function getPlural(word, size) {
  const FE = ["knife"];
  const ON = ["criterion", "phenomenon"];
  const F = ["leaf"];
  const O = ["potato", "tomato", "hero", "cargo"];
  const ABNORMAL = {
    mouse: "mice",
    child: "children",
    foot: "feet",
    tooth: "teeth",
    goose: "geese",
    person: "people",
    man: "men",
    woman: "women",
    fungus: "fungi",
    cactus: "cacti",
    stimulus: "stimuli"
  };
  const _EN = /^[a-zA-Z]+$/;
  return (getPlural = function (word2, size2) {
    if (!_EN.test(word2) || typeof size2 === "boolean" && !size2 || size2 !== void 0 && size2 < 2) {
      return word2;
    }
    const lowercase = word2.toLowerCase();
    const abnormal = ABNORMAL[lowercase];
    if (abnormal) {
      return abnormal;
    }
    const lastChars = word2.substring(word2.length - 2);
    switch (lastChars) {
      case "fe":
        return FE.includes(lowercase) ? add(word2, "ves") : word2 + "s";
      case "on":
        return ON.includes(lowercase) ? add(word2, "a") : word2 + "s";
      case "sh":
      case "ch":
        return word2 + "es";
      case "ay":
      case "ey":
      case "oy":
      case "uy":
        return word2 + "s";
      case "is":
        return add(word2, "es");
    }
    switch (lastChars.substring(1)) {
      case "f":
        return F.includes(lowercase) ? add(word2, "ves", 1) : word2 + "s";
      case "o":
        return word2 + (O.includes(lowercase) ? "es" : "s");
      case "s":
      case "x":
      case "z":
        return word2 + "es";
      case "y":
        return add(word2, "ies", 1);
    }
    return word2 + "s";
  }).apply(this, arguments);
  function add(word2, suffix, lastIndex = 2) {
    return word2.substring(0, word2.length - lastIndex) + suffix;
  }
}
export { getKrPp, getPlural };
